<template>
    <div class="base-wrapper">        
        <!-- 进入页面提示蒙层 -->
        <div class="mask" v-if="!!maskData" :class="[thisPage == 'game' && 'game-mask']">
            <div class="mask-inner">
                <div class="mask-content">
                    <p v-html="maskData.text" :class="[maskData.type != 1 && maskData.type != 2 && maskData.type != 10 && 'has-padding']"></p>
                    <div class="mask-btns" v-if="maskData.btns">
                        <button class="mask-btn" :class="[btn.className]" :data-redirect="btn.redirectTo" @click="maskBtnClick(index, $event)" v-for="(btn, index) in maskData.btns" :key="index">{{btn.text}}</button>
                    </div>
                </div>               
            </div>
        </div>
        <!-- 红包弹窗 -->
        <div class="hb-pop" v-if="hbFlagData">
            <div class="hb-pop-inner">
                <div class="hb-pop-content">
                    <img class="hb-pop-bg" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271gv8m2q1pio1jqr1ck137.png" alt>
                    <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27c8h1f0n1jvk107fvek3q.png" @click="openHbClick" class="hb-pop-open" :class="[isOpening && 'ani']" alt="">
                    <img class="hb-pop-close" @click="closeHb" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27qdt3t91f6hrvrvai2t.png" alt>
                </div>                
                <p class="hb-pop-text">{{hbFlagData.type == 1 ? '成功获得一个红包，快点开红包看看！' : '亲，快点开红包看看吧！'}}</p>
            </div>
        </div>
        <!-- toast提示 -->
        <div class="toast" v-if="toastData">
            <p class="toast-inner">
                {{toastData.text}}
            </p>
        </div>
    </div>
</template>

<script>

import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'

export default {
    data() {
        return {
            id: '',
            musicFlag: true,
            isOpening: false,
            thisPage: ''
        }
    },
    props: ['baseData'],
    computed: {
        ...mapState(['aid', 'newsId', 'isApp', 'versionSize', 'shareData', 'maskData', 'userinfo', 'toastData', 'hbFlagData', 'serverTime'])
    },
    watch: {
        toastData(val) {
            if(val) {
                setTimeout(()=> {
                    this.setToastDataAsync(null)
                }, 3000)
            }
        },
        '$route'(to, from) {
            this.thisPage = to.name
        }
    },
    mounted() {
        this.appFlagAsync(COVERAPP.Attribute.isApp())
        this.showMask()
        if(this.isApp && COVER.isEmpty(this.userinfo.user_id)) {
            this.getUserinfoAsync()
        }
        !this.isApp && COVER.isWapHidden() 
    },
    methods: {
        ...mapActions([
            'appFlagAsync',
            'setVersionSizeAsync',
            'setshareDataAsync',
            'setMaskDataAsync',
            'getUserinfoAsync',
            'checkCanGetHb',
            'setHbShowFlagAsync',
            'setToastDataAsync',
            'setResultDataAsync'
        ]),
        // 提示蒙层判断
        showMask() {
            this.checkVersion()
        },
        // 版本判断
        checkVersion() {
            let _this = this
            if(this.isApp) {
                let version = COVERAPP.Attribute.appVersion();
                let versionNum = version.split('.');
                let versionSize = parseInt(versionNum.join(''));
                this.versionSize = versionSize;
                this.setVersionSizeAsync(versionSize);
                if(versionSize < 570){
                    this.setMaskDataAsync({
                        type: 3,
                        text: '亲，封面app需升级至最新版本，<br/>才能参与抢现金红包哦！',
                        btns: [
                            {
                                className: 'arrow-btn update-btn',
                                text: '立即升级',
                                // fn() {
                                //     _this.update()
                                // }
                            }
                        ]
                    })
                }
            }           
        },
        openHbClick() {
            console.log(this.hbFlagData);
            this.openHb({
                aid: this.aid,
                pid: this.hbFlagData.id,
                userinfo: this.userinfo,
            })
        },
        openHb(data) {
            let _this = this
            _this.isOpening = true
            COVER.track(this.aid, 'click', '点击拆红包')
            COVER.$request('/lottery/cash', data, 'put').then((res) => {
                _this.isOpening = false
                if(res.errno == 0 && res.data ) {
                    let data = JSON.parse(JSON.stringify(res.data))
                    const amount = data.amount ? (data.amount / 100).toFixed(2) : ''
                    this.setResultDataAsync({
                      info: {
                        year: 2019,
                        tag: Math.floor(Math.random() * 9),
                      },
                      amount,
                    })
                    if(this.thisPage == 'game') {
                        this.$router.replace('/result')
                    } else {
                        this.$router.push('/result')
                    }
                } else if(res.errno == 1250) {
                    this.setMaskDataAsync({
                        type: 4,
                        text: '亲，微信绑定，才可以抽取现金红包哦，<br/>抽取现金后，<br/>金额将自动存入您的微信零钱哦！',
                        btns: [
                            {
                                className: 'close-btn',
                                text: '取消'
                            },
                            {
                                className: 'wxAuthorize-btn',
                                text: '确定',
                                // fn() {
                                //     _this.wxAuthorize()
                                // }
                            }
                        ]
                    })
                } else if(res.errno == 1008) {
                    this.setMaskDataAsync({
                        type: 4,
                        text: '亲，您的微信号已授权，不能重复授权哦！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    this.setToastDataAsync({
                        text: res.errmsg || '亲，红包提现失败！'
                    })
                }
            }).catch(error => {
                this.setToastDataAsync({
                    text: '亲，红包提现失败！'
                })
            })
        },
        wxAuthorize(thisE) {
            let _this = this
            COVERAPP.Method.wxAuthorize({
                callback(res) {
                    let data = typeof res == "string".toLowerCase() ? res : JSON.stringify(res)
                    if (JSON.parse(data).status == 1) {
                        _this.setMaskDataAsync(null)
                        const openid = JSON.parse(data).openid;
                        let userinfo = _this.userinfo;
                        userinfo.openid = openid;
                        const num = (+dayjs().format('YYYYMMDD')).toString(36);
                        COVER.$request('/user/weixin/bind', {
                          openid: (+userinfo.user_id).toString(36) + '_' + openid + '_' + num,
                          userinfo,
                        }, 'put').then(res => {
                          if (res.errno === 0) {
                            _this.openHb({
                                aid: _this.aid,
                                pid: _this.hbFlagData.pid,
                                userinfo: _this.userinfo,
                            })
                            return;
                          }

                          _this.setToastDataAsync({
                              text: res.errmsg,
                          })
                        });
                    }
                }
            })
        },       
        closeHb() {
            this.setHbShowFlagAsync (null)
            if(this.thisPage == 'game') {
                this.$router.replace('/')
            }
        },
        maskBtnClick(index, e) {
            let _this = this
            let target = e.target
            let fn = this.maskData.btns[index].fn
            if(fn) {
                fn()               
                return
            }
            if(target.className.indexOf('mask-back-btn') > 0) {
                this.$router.replace('/')
            } else if(target.className.indexOf('wxAuthorize-btn') > 0) {
                this.wxAuthorize()
            } else if(target.className.indexOf('update-btn') > 0) {
                this.update()
            } else if(target.className.indexOf('bindmobile-btn') > 0) {
                this.bindMobile()
            } else if(target.className.indexOf('login-btn') > 0) {
                let link = this.maskData.btns[index].link || ''
                this.login(link)
            }
            this.setMaskDataAsync(null)
        },
        login(link) {
            let _this = this
            COVERAPP.Method.OpenLogin({
                callback (ret) {
                    let userinfo = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret;
                    if (!COVER.isEmpty(userinfo.user_id)) {
                        _this.getUserinfoAsync()
                        link && setTimeout(() => {
                            _this.$router.push(link)	
                        }, 500)																														
                    }
                }
            })
        },
        bindMobile() {
            let _this = this
            COVERAPP.Method.bindMobile({
                callback(res) {
                    let result = typeof res != "string" ? JSON.stringify(res) : res
                    if (result.indexOf("success")) {
                        _this.getUserinfoAsync()
                    }                    
                }
            })
        },
        // 版本升级
        update() {
            if (COVERAPP.Attribute.isIOS()) {
                window.location.href = "https://itunes.apple.com/cn/app/id1028293650";
            } else if (COVERAPP.Attribute.isAndroid()) {
                COVER.$getScript(CONFIG.DOWNLOAD_ADDRESS).then(()=> {
                    window.location.href = download_url;
                })                
            }
        },
        //下载APP
        downLoadApp() {
            COVER.$getScript(CONFIG.DOWNLOAD_ADDRESS).then(()=> {
                COVER.downloadApp(this.aid, 14, this.newsId)
            })
        },
    }
}
</script>

<style lang="less">
    .hb-pop{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        z-index: 12;
    }
    .hb-pop-inner{
        width: 6.827697rem;
        height: 6.086957rem;
        position: relative;
        left: 50%;
        top:50%;
        margin: -3.043478rem 0 0 -3.381643rem;
        text-align: center;
        animation: hbShow 1s both;
    }
    .hb-pop-content {
        display: inline-block;
        width: 3.888889rem;
        position: relative;
    }
    .hb-pop-close {
        position: absolute;
        width: .700483rem;
        height: .700483rem;
        top: -0.305958rem;
        right: -0.37037rem;
    }
    .hb-pop-open{
        width: 1.658615rem;
        position: absolute;
        top: 1.231884rem;
        left: 1.111111rem;
        &.ani {
            perspective: 8.05153rem;
            animation: openHb ease-in-out 2s infinite;
        }
    }
    .hb-pop-text {
        color: #f8d196;
        font-size: .402576rem;
        font-weight: bold;
        line-height: 1.3;
        margin-top: .523349rem;
        white-space: nowrap;
    }
    .mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 15;
        &.game-mask {
            background-color: rgba(0, 0, 0, 0.4);
            .mask-inner {
                background-color: transparent;
            }
        }
    }
    .mask-inner{
        position: absolute;
        left: 50%;
        top:50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: .241546rem;
        min-height: 3.94525rem;
        display: flex;
        align-items: center;
        p {
            font-size: .402576rem;
            color: #f8d196;      
            line-height: 1.7;
            padding: 0 .772947rem;
            white-space: nowrap;
            text-align: center;
            &.has-padding {
                padding-top: .805153rem;
            }
        }
        .mask-btns {
            display: flex;
            justify-content: center;
            padding: .724638rem 0 .515298rem;
            .mask-btn {
                font-size: .645813rem;
                font-family: 'fzcysc_GBK';
                color: #fff;
                line-height: .990338rem;
                padding: 0 .925926rem 0 .958132rem;
                background: linear-gradient(to top, #d6291b, #f64b42);
                border-radius: .990338rem;
                box-shadow: 0 .152979rem .161031rem rgba(0, 0, 0, 0.2);
                position: relative;
                letter-spacing: .032206rem;
                margin: 0 .571659rem;
                white-space: nowrap;
                &::before {
                    content: '';
                    position: absolute;
                    left: .483092rem;
                    top: .072464rem;
                    width: .99839rem;
                    height: .072464rem;
                    background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27j0j1qj01su1iml1dp72s.png) no-repeat center center;
                    background-size: 100% 100%;
                }
                &.close-btn {
                    background: linear-gradient(to top, #515151, #999898);
                }
                &.arrow-btn {
                    line-height: 1.119163rem;
                    border-radius: 1.119163rem;
                    padding: 0 1.795491rem 0 1.207729rem;
                    margin: 0;
                    &::before {
                        width: 1.312399rem;
                        height: .088567rem;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        top: 0;
                        right: .724638rem;
                        width: .57971rem;
                        height: 100%;
                        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271nqiu9125o1js1e353o.png) no-repeat center center;
                        background-size: 100% auto;
                    }
                }
            }
        }
    }
    .toast{
        position: fixed;
        bottom: 2.5rem;
        left: 0;
        text-align: center;
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
        z-index: 6;
        -webkit-animation: fadeScale 0.5s linear both;
        animation: fadeScale 0.5s linear both;
    }
    .toast-inner{
        display: inline-block;
        font-size: 0.4rem;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        line-height: 1.5;
        padding: 0.3rem 0.8rem;
        border-radius: 1rem;   
    }


    @keyframes fadeScale{
        0%{
            opacity:0;
            transform:scale(0);
        }
        to{
            opacity:1;
            transform:scale(1);
        }
    }

    @keyframes hbShow{
        0% {
            transform: scale(0) rotateY(0deg) translateZ(.805153rem)
        }
        100% {
            transform: scale(1) rotateY(1080deg) translateZ(.805153rem)
        }
    }

    @keyframes openHb{
        0% {
            transform: rotateY(0deg)
        }
        100% {
            transform: rotateY(360deg)
        }
    }
</style>
